import { FormItemType } from '@faceup/utils'

export const simpleTextTypeDef = ['moreInfo', 'sender', 'classroom', 'closingComment'] as const
export type SimpleTextType = (typeof simpleTextTypeDef)[number]

export const usernameTextTypeDef = ['internalCommentUsername', 'chatMemberUsername'] as const
export type UsernameTextType = (typeof usernameTextTypeDef)[number]

export const specialTextTypeDef = [
  ...usernameTextTypeDef,
  'chatMessages',
  'internalCommentMessages',
  'attachments',
] as const
export type SpecialTextType = (typeof specialTextTypeDef)[number]

export type SubText = Readonly<Record<string, string | undefined>>

type GetFormItemType<T extends FormItemType, V> = {
  type: T
  value: V
}

export const fullValueFormItemTypes = [
  FormItemType.Select,
  FormItemType.MultiSelect,
  FormItemType.Scale,
  FormItemType.Rating,
  FormItemType.YesNo,
] as const

export const stringFormItemTypes = [
  FormItemType.SimpleText,
  FormItemType.Category,
  FormItemType.OrganizationalUnit,
  FormItemType.SenderName,
  FormItemType.Classroom,
  FormItemType.MultilineText,
  FormItemType.Date,
  FormItemType.Email,
  FormItemType.PhoneNumber,
  FormItemType.Number,
] as const
// MoreInformation attachments use the same per-attachment drop affordance as File:
// each voice file in input.formItems[id].value is a record of attachment ids the user dropped.
export const twoDimensionalFormItemTypes = [
  FormItemType.File,
  FormItemType.MoreInformation,
] as const
export type FullValueFormItemType = (typeof fullValueFormItemTypes)[number]
export type StringFormItemType = (typeof stringFormItemTypes)[number]
export type TwoDimensionalFormItemType = (typeof twoDimensionalFormItemTypes)[number]

export type FormItemTwoDimensional = GetFormItemType<
  TwoDimensionalFormItemType,
  Record<string, string>
>
export type FormItemFullValue = GetFormItemType<FullValueFormItemType, string>
export type FormItemString = GetFormItemType<StringFormItemType, string>

type FormItems = FormItemTwoDimensional | FormItemFullValue | FormItemString

export type RedactedTextsState = Readonly<
  Partial<Record<SimpleTextType, string>> &
    Partial<Record<SpecialTextType, SubText>> &
    Partial<Record<'formItems', Record<string, FormItems>>>
>

export type RedactedTextsWithCaseId = Readonly<RedactedTextsState & { caseId: string }>

export type RedactTwoDimensionalTextType = {
  type: 'formItems'
  id: string
  formItem: TwoDimensionalFormItemType
  itemId: string
}

export type RedactTextType =
  | { type: SimpleTextType; id?: never; itemId?: never }
  | { type: SpecialTextType; id: string; itemId?: never }
  | {
      type: 'formItems'
      id: string
      formItem: StringFormItemType | FullValueFormItemType
      itemId?: never
    }
  | RedactTwoDimensionalTextType

type Variant = 'redacted' | 'notRedacted'

export type RedactText = {
  start: number
  end: number
  variant: Variant
}
